import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ZoomableDirective } from "./directives/index";
import { D3Service } from "./d3.service";
import { SharedModule } from "app/shared/shared.module";

@NgModule({
  declarations: [ZoomableDirective],
  imports: [CommonModule, SharedModule],
  exports: [ZoomableDirective],
  providers: [D3Service],
})
export class D3Module {}
